import {NavLink, useSelector} from "umi";
import get from "lodash/get";
import {selectCurrentJourneyConfig} from "@/services/selectors";
import * as PreferencesSelectors from "@/selectors/preferencesSelectors";
import {getAreaEntryPath} from "@/constants/viewAreas";
import {navTourAnchor, tourAnchorProps} from "@/constants/tourAnchors";

export default function MenuItem({item, children}){
  const journeyConfig = useSelector(selectCurrentJourneyConfig)
  const lastAreaViews = useSelector(PreferencesSelectors.selectLastAreaViews)
  if(item.name === 'UserManagement') item.locale = "menu.reports.performance"

  if (item.journeyConfigAccessKey){
    if (!get(journeyConfig, item.journeyConfigAccessKey)) return null
  }
  const to = item.viewArea ? getAreaEntryPath(item.viewArea, lastAreaViews) : item.path
  return <NavLink to={to} {...tourAnchorProps(navTourAnchor(item.name))}>
    {children}
  </NavLink>
}
